<template>
  <div>
    <v-dialog scrollable v-model="value" max-width="800" persistent>
      <v-card>
        <v-card-text>
          <v-layout>
            <v-flex class="pa-3"> </v-flex>

            <v-flex class="text-xs-right">
              <v-btn small flat fab @click="close" :loading="loading">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-stepper v-model="step" class="elevation-0">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1">ตั้งค่าผู้ส่ง</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" step="2">เลือกขนส่ง</v-stepper-step>
            </v-stepper-header>
          </v-stepper>

          <template v-if="step == 1">
            <h3 class="title">เลือกที่อยู่ผู้ส่ง</h3>
            <shipping-address></shipping-address>

            <h3 class="title">ช่องทางการจัดส่งสินค้า</h3>
            <div class="text-xs-left">
              <v-radio-group v-model="useCustomCourier" row>
                <v-radio
                  label="ขนส่งตามที่ลูกค้าเลือก"
                  value="bycustomer"
                  color="primary"
                ></v-radio>
                <v-radio
                  label="เปลี่ยนขนส่งสำหรับทุกออเดอร์"
                  value="bymerchant"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </div>

            <div class="mt-2" v-if="useCustomCourier == 'bymerchant'">
              <v-select
                v-model="customCourier"
                :items="couriers"
                :data-vv-as="'courier code'"
                name="couriercode"
                :label="$t('Shipping Method')"
                outline
                :hide-details="errors.has('couriercode')"
                :error-messages="errors.first('couriercode')"
                v-validate="'required'"
              ></v-select>
            </div>

            <div class="text-xs-center">
              <v-btn color="grey" outline @click="close" :loading="loading">{{
                $t('cancel')
              }}</v-btn>
              <v-btn
                color="primary"
                depressed
                @click="nextStep(2)"
                :loading="loading"
                :disabled="!addresses || addresses.length == 0"
                >{{ $t('Next') }}</v-btn
              >
            </div>
          </template>
          <template v-else-if="step == 2">
            <h3 class="title">
              กรุณาตรวจสอบขนส่งอีกครั้งก่อนยืนยันการทำรายการ ({{ tmporders.length }} รายการ)
            </h3>

            <div style="max-height: 600px; overflow: auto" class="my-2">
              <template v-for="(order, index) in tmporders">
                <v-layout wrap :key="'shippop_' + order.orderid">
                  <v-flex xs12 sm3 class="py-2">
                    <v-chip small color="blue" class="white--text" disabled
                      >Order No.: {{ order.orderid }}</v-chip
                    >
                  </v-flex>
                  <v-flex xs12 sm5 class="pa-2">
                    {{ order.orderzwiz.nameaddress }}
                  </v-flex>
                  <v-flex xs12 sm4>
                    <select-shippop-courier
                      v-model="tmporders[index].courier_code"
                      :shippingtype="order.orderzwiz.shippingtype"
                      :couriers="order.shippopresult"
                      :hide-details="!errors.has(`courier_code_${index}`)"
                      :error="errors.has(`courier_code_${index}`) ? true : false"
                      :error-messages="
                        errors.has(`courier_code_${index}`)
                          ? errors.first(`courier_code_${index}`)
                          : ''
                      "
                    ></select-shippop-courier>
                    <input
                      type="hidden"
                      :data-vv-as="'courier code'"
                      :name="`courier_code_${index}`"
                      v-model="tmporders[index].courier_code"
                      v-validate="'required'"
                    />
                  </v-flex>
                  <v-flex xs12 v-if="tmporders[index].courier_code == 'SCGX'">
                    <div class="primary--text">กรุณากรอกรายละเอียดพัสดุ</div>
                    <v-layout :key="`parcel_size_${index}`">
                      <v-flex class="form-control pl-1">
                        <input
                          v-validate="'required'"
                          :name="`parcel.width`"
                          type="text"
                          v-model="tmporders[index].parcel.width"
                          :placeholder="$t('width')"
                          :data-vv-as="$t('width')"
                        />
                        <div class="error--text caption" v-if="errors.has(`parcel.width`)">
                          {{ errors.first(`parcel.width`) }}
                        </div>
                      </v-flex>

                      <v-flex class="form-control pl-1">
                        <input
                          v-validate="'required'"
                          :name="`parcel.length`"
                          type="text"
                          v-model="tmporders[index].parcel['length']"
                          :placeholder="$t('length')"
                          :data-vv-as="$t('length')"
                        />
                        <div class="error--text caption" v-if="errors.has(`parcel.length`)">
                          {{ errors.first(`parcel.length`) }}
                        </div>
                      </v-flex>
                      <v-flex class="form-control pl-1">
                        <input
                          v-validate="'required'"
                          :name="`parcel.height`"
                          type="text"
                          v-model="tmporders[index].parcel.height"
                          :placeholder="$t('height')"
                          :data-vv-as="$t('height')"
                        />
                        <div class="error--text caption" v-if="errors.has(`parcel.height`)">
                          {{ errors.first(`parcel.height`) }}
                        </div>
                      </v-flex>
                      <v-flex class="form-control pl-1">
                        <input
                          v-validate="'required'"
                          :name="`parcel.weight`"
                          type="text"
                          v-model="tmporders[index].parcel.weight"
                          :placeholder="$t('weight')"
                          :data-vv-as="$t('weight')"
                        />
                        <div class="error--text caption" v-if="errors.has(`parcel.weight`)">
                          {{ errors.first(`parcel.weight`) }}
                        </div>
                        <div class="caption grey--text">น้ำหนักสูงสุด 25kg</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider
                  :key="'shippop_divider_' + order.orderid"
                  v-if="index != tmporders.length - 1"
                ></v-divider>
              </template>
            </div>
            <v-divider />
            <div class="text-xs-center">
              <v-btn color="grey" outline :loading="loading" @click="step = 1">{{
                $t('Back')
              }}</v-btn>
              <v-btn color="primary" depressed @click="confirmShippop" :loading="loading">{{
                $t('Next')
              }}</v-btn>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <preview-shippop-cover
      v-if="showPreview"
      v-model="showPreview"
      :purchase_id="currentPaymentID"
      @closePreview="closePreview"
    ></preview-shippop-cover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectShippopCourier from './SelectShippopCourier'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'
import api from '@/api'
import PreviewShippopCover from './PreviewShippopCover.vue'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: ['value', 'orders'],
  components: {
    SelectShippopCourier,
    ShippingAddress,
    PreviewShippopCover
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      addresses: 'getShippingAddress'
    })
  },
  data() {
    return {
      step: 1,
      loading: true,
      useCustomCourier: 'bycustomer',
      customCourier: null,
      couriers: [
        {
          text: 'ไปรษณีย์ไทย EMS',
          value: 'THP'
        },
        {
          text: 'ไปรษณีย์ ลงทะเบียน',
          value: 'TP2'
        },
        {
          text: 'ไปรษณีย์ไทย (Eco-post)',
          value: 'ECP'
        },
        {
          text: 'ไปรษณีย์ไทย (EMS Special)',
          value: 'EMST'
        },
        {
          text: 'Alphafast',
          value: 'APF'
        },
        {
          text: 'Kerry Express',
          value: 'KRY'
        },
        {
          text: 'Kerry Pickup',
          value: 'KRYP'
        },
        {
          text: 'Kerry Dropoff',
          value: 'KRYD'
        },

        {
          text: 'Rush Bike',
          value: 'RSB'
        },
        {
          text: 'Skootar',
          value: 'SKT'
        },
        {
          text: 'SCG Yamato Express',
          value: 'SCG'
        },
        {
          text: 'SCG Yamato Express Chilled',
          value: 'SCGC'
        },
        {
          text: 'SCG Yamato Express Frozen',
          value: 'SCGF'
        },
        {
          text: 'SCG Express Exclusive',
          value: 'SCGX'
        },
        {
          text: 'Lalamove',
          value: 'LLM'
        },
        {
          text: 'Ninjavan',
          value: 'NJV'
        },
        {
          text: 'CJ Logistics',
          value: 'CJE'
        },
        {
          text: 'Flash Express',
          value: 'FLE'
        },
        {
          text: 'Flash Speed',
          value: 'FLES'
        },
        {
          text: 'True e-logistics',
          value: 'TRUE'
        },
        {
          text: 'Best Express',
          value: 'BEST'
        },
        {
          text: 'Bee Express',
          value: 'BEE'
        },
        {
          text: 'JWD Express Chilled',
          value: 'JWDC'
        },
        {
          text: 'JWD Express Frozen',
          value: 'JWDF'
        },
        {
          text: 'Aramex',
          value: 'ARM'
        },
        {
          text: 'J&T Express Pickup',
          value: 'JNTP'
        },
        {
          text: 'J&T Express Dropoff',
          value: 'JNTD'
        },
        {
          text: 'SHIPPOP Express Sameday',
          value: 'SPE'
        },
        {
          text: 'SHIPPOP Chilled Sameday',
          value: 'SPEC'
        },
        {
          text: 'ZTO Express',
          value: 'ZTO'
        },
        {
          text: 'Popman',
          value: 'POM'
        },
        { text: 'SPRESS (Dropoff)', value: 'EMSX' },
        { text: 'SPRESS (Pickup)', value: 'EMSXP' },
        { text: 'Makesend', value: 'MSE' },
        { text: 'Makesend Cool', value: 'MSEC' }
      ],
      tmporders: [],
      shopaddress: null,
      showPreview: false,
      currentPaymentID: null
    }
  },
  async mounted() {
    this.loading = false
  },
  methods: {
    closePreview() {
      location.reload()
    },
    async checkorderlist() {
      try {
        var options = {}

        if (this.useCustomCourier == 'bymerchant' && this.customCourier) {
          options.setallcourier = this.customCourier
        }
        var selectedAddress = this.addresses.find((el) => {
          return el.selected
        })
        if (selectedAddress) {
          options.shopaddress = selectedAddress
          var response = await this.shippopcheckorderlist(this.orders, options)
          if (response.responsecode == 200 && response.data) {
            this.tmporders = response.data.map((el) => {
              return { ...el, courier_code: null }
            })
          }
        } else {
          throw new Error('ที่อยู่ไม่ถูกต้อง')
        }
      } catch (error) {
        await this.$swal({
          title: error.message,
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    async shippopcheckorderlist(list, options) {
      var vm = this
      var orderidlist = list.map((el) => el.id)
      return new Promise((resolve, reject) => {
        api.shippopcheckorderlist(
          {
            params: { pageid: vm.selectedBot.pageid },
            body: {
              orderidlist: orderidlist.join(','),
              ...options
            }
          },
          async (error, response) => {
            //console.log(error)
            if (error) {
              if (
                error.message == 'Please insert pageaddress AND companyname AND Tel.' ||
                error.message ==
                  'Please insert zipcode in pageaddress or companyname,companyphoneno is empty'
              ) {
                var error_message = ''
                if (error.message == 'Please insert pageaddress AND companyname AND Tel.')
                  error_message = 'กรุณาใส่ชื่อ, ที่อยู่ และเบอร์โทรของผู้จัดส่ง (แก้ไขร้านค้า)'
                else if (
                  error.message ==
                  'Please insert zipcode in pageaddress or companyname,companyphoneno is empty'
                )
                  error_message =
                    'กรุณาตรวจสอบรหัสไปรษณีย์ของผู้จัดส่ง หรือ ชื่อและเบอร์โทรของผู้จัดส่งอีกครั้ง (แก้ไขร้านค้า)'

                var result = await vm.$swal({
                  title: error_message,
                  type: 'error',
                  showCancelButton: true,
                  confirmButtonText: vm.$t('ตั้งค่าร้านค้า'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
                if (result.value) {
                  vm.$emit('isEditShop', true)
                }
              } else {
                error_message = error.message
                var result = await vm.$swal({
                  title: error_message,
                  type: 'error',
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
              }

              reject(error)
            }
            resolve(response)
          }
        )
      })
    },
    close() {
      this.step = 1
      this.customCourier = null
      this.useCustomCourier = 'bycustomer'
      this.$emit('input', false)
    },
    async nextStep(step) {
      var result = await this.$validator.validateAll()

      if (!result) {
        this.goToErrorInput()
        return false
      }
      if (step == 2) {
        // console.log('check')
        this.loading = true
        await this.checkorderlist()
        this.loading = false
      }
      this.step = step
    },
    async confirmShippop() {
      var result = await this.$validator.validateAll()

      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        await this.$swal({
          title: 'ข้อมูลไม่ครบถ้วนหรือไม่สามารถจัดส่งบางออเดอร์ได้',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
        return false
      }

      this.loading = true

      let packages = cloneDeep(this.tmporders)
      packages = packages.map((el) => {
        let order = el
        delete order.shippopresult
        if (order.orderzwiz.shippingtype == 'cod_charge') {
          order.cod_amount = order.orderzwiz.amount
        }
        return { ...order }
      })

      try {
        var response = await this.shippopbooking(packages)
        if (response.responsecode == 200 && response.status) {
          var response = await this.shippopconfirm(response.purchase_id)

          if (response.responsecode == 200) {
            var result = await this.$swal({
              title: 'ส่งข้อมูลไปที่ shippop สำเร็จ',
              text: 'หมายเลขการชำระเงินคือ ' + response.purchase_id,
              type: 'success',
              confirmButtonText: 'ปริ้นใบปะหน้า',
              showCancelButton: true,
              cancelButtonText: this.$t('cancel'),
              reverseButtons: true
            })
            this.currentPaymentID = response.purchase_id
            if (result.value) {
              this.showPreview = true
            } else {
              location.reload()
            }
          } else {
            throw new Error('shippop confirm unsuccessfully')
          }
        } else {
          // response.
          // shippop_body
          throw new Error('shippop booking unsuccessfully')
        }
      } catch (error) {
        let text = ''
        if (error.response && error.response.shippop_body) {
          if (error.response.shippop_body) {
            let body = error.response.shippop_body.data
            try {
              let parcel = body[Object.keys(body)[0]]
              parcel = parcel[Object.keys(parcel)[0]]
              if (parcel.remark) text = parcel.remark
              if (parcel.err_code) text = text + ` (${parcel.err_code})`
            } catch (error) {
              console.log(error)
            }
          }
        }
        await this.$swal({
          title: 'ส่งข้อมูลไม่สำเร็จ โปรดลองอีกครั้ง',
          text: text,
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
      }
      this.loading = false
      this.close()
    },
    async shippopbooking(list) {
      var vm = this
      return new Promise((resolve, reject) => {
        api.shippopbooking(
          {
            params: { pageid: vm.selectedBot.pageid },
            body: {
              shippinglist: list
            }
          },
          async (error, response) => {
            if (error) {
              reject({ error, response })
            }
            resolve(response)
          }
        )
      })
    },
    async shippopconfirm(purchase_id) {
      var vm = this
      return new Promise((resolve, reject) => {
        api.shippopconfirm(
          {
            params: { pageid: vm.selectedBot.pageid },
            body: {
              purchase_id: purchase_id
            }
          },
          async (error, response) => {
            if (error) {
              console.log(error)
              reject(error)
            }
            resolve(response)
          }
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippopShipping.vue